import { useEffect, useState } from 'react';

import { SelectionPanel } from 'coreOld/components';
import { Column, Section, SelectButton } from 'coreOld/elements';
import { SelectionOptions } from 'coreOld/enums';
import { useAppDispatch, useAppSelector } from 'coreOld/hooks';
import { setSelectionMode } from 'coreOld/slices';
import { getDisplayName } from 'coreOld/utils';

const getTitle = (subject, selectedRowsLength) => {
  if (selectedRowsLength > 1) {
    return `${selectedRowsLength} ${subject}s have been selected`;
  }

  return `${selectedRowsLength} ${subject} has been selected`;
};

const withSelectionPanel = <T,>(WrappedComponent: React.ComponentType<T>) => {
  const WithSelectionPanel = (props: any) => {
    const { closeSelection, setCloseSelection, selectOptionsConfig, selectionType } = props;

    const dispatch = useAppDispatch();

    const { filteredCount, selectionMode } = useAppSelector((state) => state.table);

    const [selectedRows, setSelectedRows] = useState<any>();
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
      if (closeSelection) {
        onClose();
        setCloseSelection(false);
      }
    }, [closeSelection]);

    const onCheckboxClick = () => setIsModalOpen((prev) => !prev);

    const onClose = () => {
      setIsModalOpen(false);

      return () => {
        setSelectedRows([]);

        dispatch(setSelectionMode(SelectionOptions.NONE));
      };
    };

    const selectedRowsLength =
      selectionMode === SelectionOptions.FILTERED ? filteredCount?.count : selectedRows?.length;

    return (
      <>
        <SelectionPanel
          title={getTitle(selectionType, selectedRowsLength)}
          isOpen={isModalOpen}
          onClose={() => onClose()}
        >
          {selectOptionsConfig &&
            selectOptionsConfig(selectedRows).map((item, index) => (
              <Section key={index}>
                {item.section.map((column, idx) => (
                  <Column key={idx}>
                    {column.map((element, index) => {
                      if (element?.hidden) {
                        return;
                      }

                      return (
                        <SelectButton
                          key={index}
                          onClick={element.onClick}
                          disabled={element?.disabled}
                          {...element.btnProps}
                        >
                          {element.label}
                        </SelectButton>
                      );
                    })}
                  </Column>
                ))}
              </Section>
            ))}
        </SelectionPanel>

        <WrappedComponent
          setSelectedRows={setSelectedRows}
          setIsModalOpen={setIsModalOpen}
          onCheckboxClick={onCheckboxClick}
          isModalOpen={isModalOpen}
          selectedRows={selectedRows}
          selectionMode={selectionMode}
          filteredCount={filteredCount?.count}
          {...props}
        />
      </>
    );
  };

  WithSelectionPanel.displayName = `WithSelectionPanel(${getDisplayName(WrappedComponent)})`;

  return WithSelectionPanel;
};

export default withSelectionPanel;
